import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import { change as changeFieldValue, reduxForm } from 'redux-form';
import MapaVeiculo from '../mapa-veiculo/MapaVeiculo';
import alterarExibicaoDetalhamentoVeiculo from '../../actions/veiculo/alterarExibicaoDetalhamentoVeiculo';
import $ from 'jquery';
import buscarLocalizacaoVeiculo from '../../actions/veiculo/buscarLocalizacaoVeiculo';
import Autorizacao from '../../security/Autorizacao';
import { getAdminEmpresa, getFiscalEmbarque, getOperadorEmpresa, getGestorOperacoes, PERFIL_ADMIN } from '../../security/securityContext';
import ImageGrid from './ImageGrid';
import Modal from './Modal';
import selecionarVeiculo from '../../actions/veiculo/selecionarVeiculo';

export class Veiculo extends React.Component {
    constructor(props) {
        super(props)
        this.state = { selectedImg: null }
    }

    buscarLocalizacao() {
        this.props.buscarLocalizacaoVeiculo(this.props.veiculo.id, this.props.empresaSelecionada.id).then(() => {
            $('#modalLocalizacaoVeiculo').modal('show');
        })
    }

    setSelectedImg(selectedImg) {
        this.setState({ selectedImg })
    }

    exibieImagem() {
        let imagens = this.props.veiculo.imagens;
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <ImageGrid setSelectedImg={this.setSelectedImg.bind(this)} veiculo={imagens.find(it => it.principal)} tipoVeiculo={this.props.veiculo.tipoVeiculo} />
                {this.state.selectedImg && <Modal selectedImg={this.state.selectedImg} setSelectedImg={this.setSelectedImg.bind(this)} />}
            </div>
        )
    }

    render() {
        const v = this.props.veiculo;
        return (
            <React.Fragment>
                <div className="vx-row-item">
                    <div className="vx-row-item-inner vx-row-item-inner--veiculo">
                        <div className="vx-row-cell">
                            <button className="vx-row-expand-btn"
                                onClick={() => this.props.alterarExibicaoDetalhamentoVeiculo(v)}>
                                <span className="material-icons">{v.exibirDetalhe ? 'expand_less' : 'expand_more'}</span>
                            </button>
                        </div>
                        <div className="vx-row-cell">
                            {this.exibieImagem()}
                        </div>
                        <div className="vx-row-cell">
                            <span className="vx-row-cell-label">Descrição</span>
                            {v.descricao}
                        </div>
                        <div className="vx-row-cell">
                            <span className="vx-row-cell-label">Assentos</span>
                            {v.mapaVeiculoDto.quantidadeAssentos}
                        </div>
                        <div className="vx-row-cell">
                            <span className="vx-row-cell-label">Ações</span>
                            <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getAdminEmpresa(this.props.empresaSelecionada.id),
                                    getGestorOperacoes(this.props.empresaSelecionada.id),
                                    getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                    <button type="button" className="vx-act-btn vx-act-btn--delete"
                                        title="Excluir veículo"
                                        data-toggle="modal"
                                        data-target="#modalConfirmacaoExclusaoVeiculo"
                                        onClick={() => this.props.selecionar(v)}>
                                        <span className="material-icons">delete</span>
                                    </button>
                                    <button type="button" className="vx-act-btn vx-act-btn--edit"
                                        title="Editar veículo"
                                        onClick={() => {
                                            this.props.selecionarVeiculo(v);
                                            this.props.history.push('/painel-cadastro-veiculo');
                                        }}>
                                        <span className="material-icons">edit</span>
                                    </button>
                                    {v.idRastreamento &&
                                        <button type="button" className="vx-act-btn vx-act-btn--neutral"
                                            title="Localização do veículo"
                                            onClick={() => this.buscarLocalizacao()}>
                                            <span className="material-icons">location_on</span>
                                        </button>
                                    }
                                </Autorizacao>
                                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                    getAdminEmpresa(this.props.empresaSelecionada.id),
                                    getGestorOperacoes(this.props.empresaSelecionada.id),
                                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                                    getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                                    <button type="button" className="vx-act-btn vx-act-btn--neutral"
                                        title="Registrar manutenção"
                                        onClick={() => this.props.history.push(`/painel-registro-manutencao-veiculo?veiculo=${v.id}`)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tools" viewBox="0 0 16 16">
                                            <path d="M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.27 3.27a.997.997 0 0 0 1.414 0l1.586-1.586a.997.997 0 0 0 0-1.414l-3.27-3.27a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3c0-.269-.035-.53-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814zm9.646 10.646a.5.5 0 0 1 .708 0l2.914 2.915a.5.5 0 0 1-.707.707l-2.915-2.914a.5.5 0 0 1 0-.708M3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026z"/>
                                        </svg>
                                    </button>
                                </Autorizacao>
                            </div>
                        </div>
                    </div>
                </div>
                {v.exibirDetalhe ? <MapaVeiculo mapaVeiculo={v.mapaVeiculoDto} /> : ''}
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
});

export default withRouter(connect(mapStateToProps, {
    changeFieldValue,
    alterarExibicaoDetalhamentoVeiculo,
    buscarLocalizacaoVeiculo,
    selecionarVeiculo
})(reduxForm({
    form: 'formularioPainelCadastroVeiculo'
})(Veiculo)))
